import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PatientPortalService } from '../patient-portal.service';
import { PatientPortalRescheduleComponent } from '../patient-portal-reschedule/patient-portal-reschedule.component';
import { PatientPortalCheckInComponent } from '../patient-portal-check-in/patient-portal-check-in.component';
import { PatientPortalConfirmAppointmentComponent } from '../patient-portal-confirm-appointment/patient-portal-confirm-appointment.component';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import moment from 'moment';
import { CommMethodEnum } from 'src/app/models/enum/comm-method.enum';
import { PatientCaseWorkItemFormDataModel } from 'src/app/models/forms/data/patient-case-work-item-form-data.model';
import { Globals } from 'src/app/globals';
import { TdoMiniCalendarComponent } from 'src/app/tdo-controls/common/tdo-mini-calendar/tdo-mini-calendar.component';
import { PatientPortalRequestAppointmentComponent } from '../patient-portal-request-appointment/patient-portal-request-appointment.component';
import { DataARLedgerListModel } from '../../ar/models/data-ar-ledger-list.model';
import { MessagingService } from 'src/app/services/messaging.service';
import { MessagingConstants } from 'src/app/models/MessagingConstants';
import { UserService } from 'src/app/services/user.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { PatientPortalCorrespondenceComponent } from '../patient-portal-correspondence/patient-portal-correspondence.component';
import { ToastrService } from 'ngx-toastr';
import { TreatmentPlanningDataModel } from '../../treatment-planning/models/treatment-planning-data.model';
import { DialogService } from 'src/app/services/dialog.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ApptStatusEnum } from 'src/app/models/enum/appt-status.enum';
import { PatientDataAppointmentModel } from 'src/app/models/appointments/patient-data-appointment.model';

@Component({
  selector: 'app-patient-portal-home',
  templateUrl: './patient-portal-home.component.html',
  styleUrls: ['./patient-portal-home.component.css']
})
export class PatientPortalHomeComponent implements OnInit {
  @ViewChild('calendar') calendar: TdoMiniCalendarComponent;

  Patient: any;
  PatientId: string;
  activeForm: any;

  patientInformationComplete: boolean = true;
  isLoading: boolean = false;
  formsLoading: boolean = false;
  patientInformation: any = {};

  activeAppointment: PatientDataAppointmentModel;
  fetchFormsSubscription: any;
  infoProgress: number = 0.5;
  activeAppointmentId = "1";
  hasIncompleteForm: boolean = false;
  
  patientBirthday: moment.Moment;
  appointments: PatientDataAppointmentModel[];

  formsPending: any[] = [];

  messages: any[] = [
    { message: "testing", read: false }
  ];
  DOCUMENT_TAG: DOCUMENT_TAG
  @ViewChild('imageView') imageView: any;

  patientPhoneNum: string;
  patientEmail: string;
  patientAddress: string;
  moment = moment;
  days: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday'];
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  patientForms: PatientCaseWorkItemFormDataModel[] = [];
  selectedCaseWorkItemFormsID: string = null;
  checkinQRCodeText: string = "";
  daysToHighlight: number[] = []
  oldAppointments: any = [];
  patientTransactions: DataARLedgerListModel[] = [];
  selectedDate: Date;
  patientMissingInfo: string = "";
  messagingSubscription: any;
  LOCID = parseInt(localStorage.getItem('LOCID'));
  isSendingSMS: boolean = false;
  //patientTreatments: TreatmentPlanningDataModel[];
  patientTreatments: any[];
  selectedTreatmentPlanningID: string;

  isTabletPortrait = false;
  isTabletLandscape = false;
  isHandsetPortrait = false;
  isFullScreen = false;
  isformViewMinimized = false;
  isRightPanelMinimized = false;
  
  // iPad detection properties
  isIPad = false;
  screenWidth = 0;
  screenHeight = 0;
  devicePixelRatio = 1;

  constructor(
    private readonly staticDataService: StaticDataService,
    private readonly router: Router,
    private readonly patientPortalService: PatientPortalService,
    private readonly dialog: MatDialog,
    private readonly globals: Globals,
    private readonly messagingService: MessagingService,
    private readonly dialogService: DialogService,
    private readonly toastr: ToastrService,
    private readonly responsive: BreakpointObserver

  ) {
    this.patientInformation = JSON.parse(localStorage.getItem('storedPatient'));
    this.DOCUMENT_TAG = DOCUMENT_TAG;
    this.PatientId = this.patientInformation.authdata.patientid;
  }

  ngOnInit() {
    // Get device screen dimensions and pixel ratio
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    this.devicePixelRatio = window.devicePixelRatio || 1;
    
    // Detect iPad 9.7-inch (2048x1536 native resolution)
    // When zoomed to 75% or 50%, we still want to use tablet layout
    const isIpad97Inch = this.detectIPad97Inch();
    
    this.responsive.observe([
      Breakpoints.TabletPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletLandscape])
      .subscribe(result => {

        this.isFullScreen = false;
        this.isHandsetPortrait = false;
        this.isTabletPortrait = false;
        this.isTabletLandscape = false;

        // If it's an iPad 9.7-inch at zoomed resolution (50% or more), force tablet mode
        if (isIpad97Inch) {
          console.log('iPad 9.7-inch detected with resolution:', this.screenWidth, 'x', this.screenHeight, 
            'pixel ratio:', this.devicePixelRatio);
            
          // Check orientation and set the appropriate tablet view
          if (this.screenWidth < this.screenHeight) {
            this.isTabletPortrait = true;
          } else {
            this.isTabletLandscape = true;
          }
          
          this.isIPad = true;
        } else {
          // Standard breakpoint detection for other devices
          const breakpoints = result.breakpoints;
          if (breakpoints[Breakpoints.TabletPortrait]) {
            this.isTabletPortrait = true;
          }
          else if (breakpoints[Breakpoints.HandsetLandscape]) {
            this.isHandsetPortrait = true;
          }
          else if (breakpoints[Breakpoints.HandsetPortrait]) {
            this.isHandsetPortrait = true;
          }
          else if (breakpoints[Breakpoints.TabletLandscape]) {
            this.isTabletLandscape = true;
          }
          else {
            this.isFullScreen = true;
          }
        }
      });

    this.init();
    
    // Add window resize event listener to handle zoom level changes
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  init() {
    // add QR code icon that opens check in
    // create a new 'confirm appointment' page
    // disable confirm if already confirmed

    if (UserService.authToken && !this.staticDataService.isReady) {
      this.staticDataService.refreshValues();
    }

    const promises = [
      this.getDataPatient(this.PatientId),
      this.getPatientAppointments(),
      this.getPatientGeneralForms(),
      this.getPatientTransactions(),
      this.getPatientTreatmentPlans()
    ];

    this.isLoading = true;

    Promise.all(promises).then((results: any[]) => {

      this.Patient = results[0].ThePatient;
      this.globals.ThePatient = results[0].ThePatient;
      this.patientBirthday = this.Patient.BirthDate ? moment(this.Patient.BirthDate) : null;

      this.analyzePatientInformation();
      this.GetComms();

      this.appointments = results[1].map(appointment => {
        const appointmentDate = new Date(appointment.StartDate);
        appointment.appointmentDate = moment(appointmentDate);
        appointment.displayTitle = `${this.days[appointmentDate.getDay()]}, ${this.months[appointmentDate.getMonth()]} ${this.returnDatFormated(appointmentDate.getDate())}, ${appointmentDate.getFullYear()} at ${this.getFormatedTime(appointmentDate.getHours(), appointmentDate.getMinutes())}`;

        if (appointment.dataDoctor4Info?.dataContact) {
          appointment.doctor = `Dr. ${appointment.dataDoctor4Info.dataContact.LastName}`;
          appointment.doctorFullName = `Dr. ${appointment.dataDoctor4Info.dataContact.FirstName} ${appointment.dataDoctor4Info.dataContact.LastName}`;
        }
        return appointment;
      }

      );

      this.sortAppointments();
      this.loadPatientForms(results[2]);
      this.patientForms = results[2];
      this.patientForms = this.patientForms.sort((a, b) => {
        return b.Status.localeCompare(a.Status);
      });

      const transactions: DataARLedgerListModel[] = results[3];

      this.patientTransactions = [];

      this.patientTransactions = transactions.filter(a => a.isShowOnLedger === true && a.AmountDuePatient > 0);
      this.patientTransactions.forEach(transaction => {
        transaction.ItemDate = moment(transaction.PostDate);
      });

      this.patientTransactions = this.patientTransactions.sort((a, b) => {
        const d1 = new Date(a.PostDate);
        const d2 = new Date(b.PostDate);
        return d2.getTime() - d1.getTime();
      });


      if (this.appointments.length) {
        this.selectAppointment(this.appointments[0]);
      }

      this.patientTreatments = results[4];
      this.patientTreatments = this.patientTreatments.sort((a, b) => {
        return b.Status.localeCompare(a.Status);
      });

      this.isLoading = false;
    }, err => {
      this.displayMessage("Error", "Something went wrong");
      this.isLoading = false;
    });

    this.setComponentMessageSub();
  }

  loadPatientForms(forms: PatientCaseWorkItemFormDataModel[]) {
    forms = forms.sort((a, b) => {
      return b.Status.localeCompare(a.Status);
    });
    this.patientForms = forms;
  }

  GetComms() {
    const phoneNums = this.Patient.dataContact.dataContactComms
      .filter(o => o.enumCommMethodID === CommMethodEnum.Phone || o.enumCommMethodID === CommMethodEnum.Mobile);

    if (phoneNums.length > 0) {
      const preferredNum = phoneNums.find(o => o.isPreferred);

      if (preferredNum !== null && preferredNum !== undefined) {
        this.patientPhoneNum = preferredNum.Address;
      }
      else {
        this.patientPhoneNum = phoneNums[0].Address;
      }
    }
    else {
      this.patientPhoneNum = 'No phone number';
    }

    const emails = this.Patient.dataContact.dataContactComms
      .filter(o => o.enumCommMethodID === CommMethodEnum.Email);

    if (emails.length > 0) {
      const preferredNum = emails.find(o => o.isPreferred);

      if (preferredNum !== null && preferredNum !== undefined) {
        this.patientEmail = preferredNum.Address;
      }
      else {
        this.patientEmail = emails[0].Address;
      }
    }
    else {
      this.patientEmail = 'No phone number';
    }

    const address = this.Patient.dataContact.dataAddresses[0];
    const hasAddr = address !== null && address !== undefined;
    this.patientAddress = 'No address';

    if (hasAddr) {
      this.patientAddress = '';
      if (address.Address1) { this.patientAddress += address.Address1; }
      if (address.Address2) { this.patientAddress += ` ${address.Address2}`; }
      if (address.City) { this.patientAddress += ` ${address.City}`; }
      if (address.State) { this.patientAddress += `, ${address.State}`; }
      if (address.PostCode) { this.patientAddress += ` ${address.PostCode}`; }
    }
  }

  sortAppointments() {

    // sort by date - sooner to later
    // put old appointments (after today) in the back
    // disable check in and reschedule for old appointments

    if (this.appointments.length == 0) {
      return;
    }

    this.appointments = this.appointments.sort((a, b) => {
      const d1 = new Date(a.StartDate);
      const d2 = new Date(b.StartDate);
      return d1.getTime() - d2.getTime();
    });

    this.oldAppointments = [];

    for (let index = this.appointments.length - 1; index >= 0; index--) {
      const appointment = this.appointments[index];
      const now = new Date();
      const apptDate = new Date(appointment.StartDate);
      if (appointment.enumApptStatusId == ApptStatusEnum.Canceled) {
        appointment.isCancelled = true;
        appointment.isOld = true;
      }

      if (apptDate < now) {
        const secondsInBetween = (now.getTime() - apptDate.getTime()) / 1000;
        if (secondsInBetween > (60 * 60 * 24)) {
          appointment.isOld = true;
          appointment.smsSent = true;
          this.oldAppointments = this.oldAppointments.concat(this.appointments.splice(index, 1));
        }
      }
    }
  }

  activateImageView() {
    this.imageView.handleUploadClicked();
  }

  confirmAppointment(appointment: PatientDataAppointmentModel) {
    console.log('confirmAppointment: ', appointment);
    //const appointment = this.appointments.find(a => a.appointmentId == appointmentId);

    const dialogRef = this.dialog.open(PatientPortalConfirmAppointmentComponent, {
      width: "95%",
      height: "75%",
      maxHeight: "350px",
      maxWidth: "500px",
      data: {
        PatientId: this.PatientId,
        AppointmentId: appointment.AppointmentId,
        appointmentName: appointment.displayValue,
        appointment: appointment,
      }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          //const index = this.appointments.findIndex(a => a.AppointmentId == appointment.AppointmentId);
          this.displayMessage("Success", "Appointment confirmed");
          this.init();
        } else if (result === 'error') {
          this.displayMessage("Error", "Something went wrong");
        }
      },
      err => {
      }
    );
  }

  displayMessage(type, message) {
    // this.snackBar.open(message, type, {
    //   duration: 3000,
    //   verticalPosition: "top"
    // });
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else
      this.toastr.success(message, null, { timeOut: 3000 });
  }

  getAppointmentForms(appointment: PatientDataAppointmentModel) {
    this.formsPending.length = 0
    this.hasIncompleteForm = false;

    this.hasIncompleteForm = false;
    this.patientForms.forEach(form => {
      if (form.Status !== "Completed") {
        this.hasIncompleteForm = true;
        this.formsPending.push(form);
      }
    });
  }

  getFormatedTime(hour: number, minutes: number) {

    let timePeriod = 'am';
    if (hour >= 12) {
      timePeriod = 'pm';
    }

    if (hour > 12) {
      hour = hour - 12;
    }

    let newMinutes = ''

    if (minutes < 10) {
      newMinutes = `0${minutes}`;
    } else {
      newMinutes = `${minutes}`;
    }

    return `${hour}:${newMinutes}${timePeriod}`
  }

  returnDatFormated(day: number) {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }

  getPatientAppointments() {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getPatientAppointments(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getPatientTransactions() {
    let promise = new Promise((resolve, reject) => {
      //this.arService.getLedgerForPatient2(this.PatientId)
      this.patientPortalService.getPatientTransactions(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getPatientGeneralForms() {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getPatientForms(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  analyzePatientInformation() {

    const patientContact = this.Patient.dataContact;
    const addresses = patientContact.dataAddresses;
    const comms = patientContact.dataContactComms;
    const emergencyContacts = this.Patient.dataPatientContacts;

    let contactComplete = true;
    let addressComplete = true;
    let commComplete = true;
    let emergencyContactComplete = true;

    const contactRequiredFields: string[] = [
      'FirstName', 'LastName',
    ];

    const addressRequiredFields: string[] = [
      'Address1', 'City', 'PostCode', 'State',
    ];

    const commRequiredFields: string[] = [
      'Address', 'CommMethID',
    ];

    const emergencyRequiredFields: string[] = [
      'FirstName', 'LastName',
    ];
    contactRequiredFields.forEach(key => {
      if (!patientContact[key] || patientContact[key] == '') {
        contactComplete = false;
      }
    });

    if (!addresses.length) {
      addressComplete = false;
    } else {

      let flag = false;
      addresses.forEach(address => {
        let addressFlag = true;
        addressRequiredFields.forEach(key => {
          if (!address[key] || address[key] == '') {
            addressFlag = false;
          }
        });
        if (addressFlag) {
          flag = true;
        }
      });

      addressComplete = flag;
    }

    if (!comms.length) {
      commComplete = false;
    } else {

      let flag = false;
      comms.forEach(comm => {
        let commFlag = true;
        commRequiredFields.forEach(key => {
          if (!comm[key] || comm[key] == '') {
            commFlag = false;
          }
        });
        if (commFlag) {
          flag = true;
        }
      });

      commComplete = flag;
    }

    if (!emergencyContacts.length) {
      emergencyContactComplete = false;
    } else {

      let emergencyContactCompletedFlag = true;
      emergencyContacts.forEach(emergencyContact => {
        emergencyRequiredFields.forEach(key => {
          if (!emergencyContact.dataContact[key] || emergencyContact.dataContact[key] == '') {
            emergencyContactCompletedFlag = false;

          }
        });

      });
      emergencyContactComplete = emergencyContactCompletedFlag;
    }

    this.patientInformationComplete = contactComplete && addressComplete && commComplete && emergencyContactComplete;
    if (!this.patientInformationComplete) {

      this.patientMissingInfo += contactComplete ? " Contact First/Last name missing." : "";
      this.patientMissingInfo += addressComplete ? " Addres information missing." : "";
      this.patientMissingInfo += commComplete ? " Communication information missing." : "";
      this.patientMissingInfo += emergencyContactComplete ? " Emergency contact information missing." : "";

    }
    else
      this.patientMissingInfo = "";
  }

  getDataPatient(patientId: string) {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getPatientInfo(patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  selectAppointment(appointment: PatientDataAppointmentModel) {
    if (appointment.isCancelled) 
      return;
    this.activeAppointment = appointment;
    this.activeForm = null;
    this.checkinQRCodeText = `${this.PatientId}/${this.activeAppointment.AppointmentId}`;

    if (this.activeAppointmentId === appointment.AppointmentId) {
      return;
    }

    this.activeAppointmentId = appointment.AppointmentId;
    this.getAppointmentForms(appointment);
  }

  printAppointment(appointment) {
    this.globals.appointmentData = JSON.stringify(appointment);
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - 600) / 2 / systemZoom + dualScreenLeft
    const top = (height - 800) / 2 / systemZoom + dualScreenTop
    const appointmentUrl = 'patientportal/appointment/print';
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=800',
      'width=600',
      `top=${top}`,
      `left=${left}`
    ].join(',');
    let storageName = 'printappointment';
    let itemToStore = {};
    let postClosureEvents = [];
    const settingsUrl = this.router.serializeUrl(
      this.router.createUrlTree([appointmentUrl])
    );


    this.messagingService.openPopUpWindow(appointmentUrl, windowOptions, storageName, itemToStore, postClosureEvents, true, storageName);

  }
  checkInAppointment(appointment) {
    const dialogRef = this.dialog.open(PatientPortalCheckInComponent, {
      width: "90%",
      height: "90%",
      data: {
        PatientId: this.PatientId,
        AppointmentId: appointment.AppointmentId,
        appointmentName: appointment.displayTitle,
      }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.displayMessage("Success", "Request sent");
        }
      },
      err => {
      }
    );
  }

  rescheduleAppointment(appointment) {
    const dialogRef = this.dialog.open(PatientPortalRescheduleComponent, {
      width: "90%",
      height: "350px",
      maxWidth: "500px",
      data: {
        appointment: appointment
      }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.patientPortalService.rescheduleAppointment(this.PatientId, appointment.AppointmentId, result, this.patientInformation.fullname, this.patientPhoneNum)
            .subscribe(
              result => {
                if (result) {
                  this.displayMessage("Success", "Request sent");
                } else if (result === 'error') {
                  this.displayMessage("Error", "Error sending request, please try later.");
                }
              },
              err => {
                this.displayMessage("Error", "Error sending request, please try later.");
              }
            );
        }
      },
      err => {
      }
    );
  }

  requestAppointment() {
    const dialogRef = this.dialog.open(PatientPortalRequestAppointmentComponent, {
      width: "90%",
      height: "350px",
      maxWidth: "500px",
      data: {
        date: `${this.days[this.selectedDate.getDay()]}, ${this.months[this.selectedDate.getMonth()]} ${this.returnDatFormated(this.selectedDate.getDate())}, ${this.selectedDate.getFullYear()}`
      }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.patientPortalService.requestAppointment(this.PatientId, this.selectedDate, result, this.patientInformation.fullname, this.patientPhoneNum)
            .subscribe(
              result => {
                if (result) {
                  this.displayMessage("Success", "Appointment Request sent");
                } else if (result === 'error') {
                  this.displayMessage("Error", "Error sending appointment request, please try later.");
                }
              },
              err => {
                this.displayMessage("Error", "Error sending appointment request, please try later.");
              }
            );
        }
      },
      err => {
      }
    );
  }

  editProfilePressed() {
    this.router.navigate(['/patientportal/profile']);
  }

  navigateToForm(task) {
    this.router.navigate([`/patientportal/form/${task.CaseWorkItemFormsId}`])
  }

  loadFormToContainer(form: PatientCaseWorkItemFormDataModel) {
    if (this.selectedCaseWorkItemFormsID == form.CaseWorkItemFormsId)
      return;
    if (!this.isRightPanelMinimized)
      this.toggleRightPanel();
    this.activeForm = form;
    this.selectedCaseWorkItemFormsID = form.CaseWorkItemFormsId;
    this.selectedTreatmentPlanningID = undefined;
    console.log("loadFormToContainer: ", form);
    this.globals.currentPatientCaseWorkItemFormsID = form.CaseWorkItemFormsId;
    
    // Ensure forms container is properly styled to prevent horizontal scrolling
    setTimeout(() => {
      const formContainers = document.querySelectorAll('.form-display, .general-container, #master-form-container, #main-form-container');
      formContainers.forEach(container => {
        (container as HTMLElement).style.overflowX = 'hidden';
        (container as HTMLElement).style.maxWidth = '100%';
      });
    }, 100);

    this.messagingService.sendComponentMessage(MessagingConstants.FORM_EDIT_START, {
      caseWorkItem: null,
      CaseWorkItemFormsId: form.CaseWorkItemFormsId,
      enumCustomFormId: form.enumCustomFormID,
      form
    });
  }

  loadTreatmentToContainer(treatment: TreatmentPlanningDataModel) {
    if (this.selectedTreatmentPlanningID == treatment.TreatmentPlanningID)
      return;
    if (!this.isRightPanelMinimized)
      this.toggleRightPanel();
    this.selectedTreatmentPlanningID = treatment.TreatmentPlanningID;
    this.selectedCaseWorkItemFormsID = undefined;
    console.log("loadTreatmentToContainer: ", treatment);
    this.globals.currentTreatmentPlanID = treatment.TreatmentPlanningID;
    
    // Ensure forms container is properly styled to prevent horizontal scrolling
    setTimeout(() => {
      const formContainers = document.querySelectorAll('.form-display, .general-container, #master-form-container, #main-form-container');
      formContainers.forEach(container => {
        (container as HTMLElement).style.overflowX = 'hidden';
        (container as HTMLElement).style.maxWidth = '100%';
      });
    }, 100);
    
    this.messagingService.sendComponentMessage(MessagingConstants.FORM_EDIT_START, {
      TreatmentPlanId: treatment.TreatmentPlanningID,
      ParentDescription: treatment.ParentDescription,
      enumCustomFormId: '00000039-1000-0000-0000-000000000011'
    });
  }

  refreshCountForForm(formId) {
    this.formsLoading = true;
    this.getAppointmentFormProgress(formId)
      .then((result: any) => {

        let formIndex = 0;
        this.formsPending.forEach((form, i) => {
          if (form.FormId === result.FormId) {
            formIndex = i;
          }
        });
        this.formsPending.splice(formIndex, 1, result);

        this.formsLoading = false;
      }, err => {
        this.formsLoading = false;
      });
  }

  getAppointmentFormProgress(formId) {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getAppointmentFormProgress(formId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  openMap() {
    const mapUrl = "https://www.google.com/maps/search/?api=1&query=" + this.activeAppointment.locationAddress;
    window.open(mapUrl, '_blank');
  }

  calendarUpdate(calendarDate: Date) {
    this.selectedDate = calendarDate;
    if (this.appointments) {
      this.daysToHighlight = this.appointments.filter((appt) => {
        const appDate = new Date(appt.StartDate);
        return appDate.getFullYear() == calendarDate.getFullYear() && appDate.getMonth() == calendarDate.getMonth();
      }).map(p => {
        const date = new Date(p.StartDate);
        return date.getDate();
      });
    }
    else
      this.daysToHighlight = [];
  }

  openCorrespondence(appointmentId: any = null) {

    const dialogRef = this.dialog.open(PatientPortalCorrespondenceComponent, {
      width: "95%",
      height: "75%",
      maxHeight: "800px",
      maxWidth: "700px",
      data: {
        activeAppointmentId: appointmentId,
        appointments: this.oldAppointments.concat(this.appointments),
        patientId: this.PatientId,
      }
    });
  }

  SendToMobileKey(event: any, appointment: any) {
    if (event.key === "Enter") {
      this.sendToMobile();
    }
  }

  sendToMobile() {
    this.isSendingSMS = true;
    this.patientPortalService.sendSMSAppointment(this.PatientId, this.activeAppointment.AppointmentId).subscribe(
      result => {
        if (result) {
          this.activeAppointment.smsSent = true;
          this.displayMessage("Success", "Appointment SMS sent.");
        } else if (result === 'error') {
          this.displayMessage("Error", "Error sending appointment information, please try later.");
        }
      },
      err => {
        console.log(err);
        if (err.status == 400)
          this.displayMessage("Error", `Error sending appointment information: ${err.error.Message}`);
        else
          this.displayMessage("Error", "Error sending appointment information, please try later.");

        this.isSendingSMS = false;

      },
      () => {
        this.isSendingSMS = false;
      }
    );
  }

  getPatientTreatmentPlans() {
    let promise = new Promise((resolve, reject) => {
      this.patientPortalService.getPatientTreatmentPlans(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }


  setComponentMessageSub() {
    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {
        if (response.event === MessagingConstants.RELOAD_PATIENT_FORMS) {
          this.patientPortalService.getPatientForms(this.PatientId).subscribe(resp => {
            if (resp) {
              this.loadPatientForms(resp);
            }
          },
            error => {
              this.displayMessage("Error", "Error loading Patient forms.");
            }
          );
        }
        else if (response.event === MessagingConstants.FORM_ITEM_SAVED) {
          this.activeForm.Status = 'Started';
        }
        else if (response.event === MessagingConstants.PATIENT_TREATMENT_APPROVED) {
          const approvedTreatment = this.patientTreatments.find(a => a.TreatmentPlanningID == response.data.treatmentPlanId);
          approvedTreatment.Status = 'Accepted';
          this.dialogService.openConfirmDialog(`Do you want to request an appointment for treatment <br/><b>${approvedTreatment.Description}</b>?`).subscribe((confirmAppointment) => {
            if (confirmAppointment)
              this.requestAppointment();
          },
            error => {
              this.displayMessage("Error", "Error requesting appointment for treatment.");
            }
          );
        }
        else if (response.event === MessagingConstants.PATIENT_TREATMENT_REJECTED) {
          const approvedTreatment = this.patientTreatments.find(a => a.TreatmentPlanningID == response.data.treatmentPlanId);
          approvedTreatment.Status = 'Rejected';
        }
      });
  }

  toggleFormView(event: Event): void {
    event.stopPropagation(); // Prevent the panel from collapsing/expanding
    this.isformViewMinimized = !this.isformViewMinimized;
  }

  toggleRightPanel(){
    this.isRightPanelMinimized = !this.isRightPanelMinimized;    
  }

  /**
   * Detects if the device is likely a 9.7-inch iPad
   * at any zoom level of 50% or higher
   */
  detectIPad97Inch(): boolean {
    // User agent detection (auxiliary method, not primary detection)
    const ua = navigator.userAgent;
    const isIPadByUA = /iPad/.test(ua) || (/Macintosh/.test(ua) && 'ontouchend' in document);
    
    // iPad 9.7 inch has a native resolution of 2048x1536
    // At 100% zoom, devicePixelRatio is 2 in the browser
    // At 75% zoom, devicePixelRatio would be approximately 1.5
    // At 50% zoom, devicePixelRatio would be approximately 1.0
    
    // Check if device has proper dimensions for iPad 9.7 inch with scaled resolution
    // We look for reasonable approximations for different zoom levels
    const { width, height } = window.screen;
    const minDimension = Math.min(width, height);
    const maxDimension = Math.max(width, height);
    
    // If it's close to iPad dimensions at various zoom levels (50% and above)
    // Full resolution: 2048x1536 with pixelRatio=2 → effective 1024x768
    // 75% zoom: 2048x1536 with pixelRatio≈1.5 → effective ~1365x1024
    // 50% zoom: 2048x1536 with pixelRatio≈1.0 → effective ~2048x1536
    
    // This matches either:
    // 1. iPad 9.7" at 100% zoom (1024x768 effective) or similar
    // 2. iPad 9.7" at 75% zoom (1365x1024 effective) or similar
    // 3. iPad 9.7" at 50% zoom (2048x1536 effective) or similar
    
    const isIPad97InchResolution = (
      // Check for iPad dimensions at various zoom levels
      (minDimension >= 750 && minDimension <= 850 && maxDimension >= 1000 && maxDimension <= 1100) || // ~100% zoom
      (minDimension >= 950 && minDimension <= 1050 && maxDimension >= 1300 && maxDimension <= 1400) || // ~75% zoom
      (minDimension >= 1500 && minDimension <= 1600 && maxDimension >= 2000 && maxDimension <= 2100)    // ~50% zoom
    );
    
    // If we detect iPad-like dimensions or have iPad user agent at a zoom level ≥ 50%
    // we'll use the tablet layout
    console.log('iPad detection:', 
                'UA match:', isIPadByUA, 
                'Resolution match:', isIPad97InchResolution, 
                'Dimensions:', width, 'x', height, 
                'Pixel ratio:', this.devicePixelRatio);
    
    return isIPadByUA || isIPad97InchResolution;
  }
  
  /**
   * Handles browser window resize events to adjust the layout
   * when zoom level changes
   */
  handleResize() {
    // Recalculate current screen dimensions and check iPad status 
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.devicePixelRatio = window.devicePixelRatio || 1;
    
    const isIpad97Inch = this.detectIPad97Inch();
    
    if (isIpad97Inch) {
      // Adjust layout for iPad based on current orientation
      this.isFullScreen = false;
      this.isHandsetPortrait = false;
      
      if (this.screenWidth < this.screenHeight) {
        this.isTabletPortrait = true;
        this.isTabletLandscape = false;
      } else {
        this.isTabletPortrait = false;
        this.isTabletLandscape = true;
      }
      
      this.isIPad = true;
    }
  }
  
  // Handle cleanup when component is destroyed
  ngOnDestroy() {
    // Remove the resize event listener to prevent memory leaks
    window.removeEventListener('resize', this.handleResize.bind(this));
    
    if (this.messagingSubscription) {
      this.messagingSubscription.unsubscribe();
    }
  }
}

